import React from 'react'
import NotificationGeneric from './NotificationGeneric'

const NotificationError = (props) => {
  return <NotificationGeneric {...props} wrapperClass="notification-error" />
}

export default NotificationError
